import { useEffect } from 'react';
import { useIdentityAuth } from '@auth/IdentityAuthContext';
import { useTheme } from '@contexts/ThemeContext';
import { QikServeLogo } from '@components/common/Logo';
import { useTranslation } from 'react-i18next';

export const Login = () => {
  const { login, isLoading, isAuthenticated } = useIdentityAuth();
  const { clientTheme } = useTheme();
  const { t } = useTranslation();

  const BrandLogo = clientTheme?.Logo ?? QikServeLogo;

  useEffect(() => {
    if (window.location.pathname.startsWith('/auth/')) {
      return;
    }

    if (!isLoading && !isAuthenticated) {
      login(window.location.pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isAuthenticated]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: 'var(--spacing-md)',
        backgroundColor: 'var(--color-background-secondary)',
        color: 'var(--color-text-primary)',
        fontFamily: 'var(--font-sans)',
      }}
    >
      <BrandLogo size={48} />
      <div style={{ color: 'var(--color-text-secondary)' }}>
        {t('login.redirecting')}
      </div>
      <div
        style={{
          width: '24px',
          height: '24px',
          border: '2px solid var(--color-border-primary)',
          borderTop: '2px solid var(--color-interactive-primary)',
          borderRadius: 'var(--border-radius-full)',
          animation: 'spin 1s linear infinite',
        }}
      />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Login;
